
import utils from "@/utils";
import { Component, Vue, Provide } from "vue-property-decorator";

@Component
export default class Recovery extends Vue {
  $store: any;
  $confirm: any;
  $message: any;
  @Provide() tabelHeight: number = window.innerHeight;  //窗口高度
  @Provide() that = this;
  @Provide() stringOrderBy = "32 desc"; //排序
  @Provide() daepickervalue?: any = "";
  @Provide() gridData: any = [];
  @Provide() options?: any[];
  @Provide() queryInfo = {
    query: "",
    pageNum: 1, //当前页
    pageSize: 10, //当前每页显示多少条
  };
  @Provide() total = 0;
  @Provide() col: any = this.$store.state.col;
  @Provide() dropCol: any = this.$store.state.dropCol;
  @Provide() switchValue = false;

  @Provide() list: any = []; //数据
  @Provide() valueTime: any = []; //时间范围
  @Provide() teacherName: any = []; //导师筛选名称
  @Provide() courseName: any = []; //课程筛选名称
  @Provide() headMaster: any = []; //班主任筛选名称
  @Provide() value = ""; //导师筛选值
  @Provide() coursevalue = ""; //课程筛选值
  @Provide() headMasterValue = ""; //班主任筛选值

  /**
  * @description: 在课节信息中 对于table column的fieldName进行对应过滤 order by 字段排序
  * @param {string} name
  * @return void
  */
  switchfield(name: string) {
    switch (name) {
      case "cid.classStartName": //1
        return "25";
      case "tid.teacherName": //1
        return "10";
      case "coid.courseName": //1
        return "6";
      case "tid.teacherPay": //1
        return "11";
      case "cid.classRate": //1
        return "23";
      case "cid.types": //1
        return "22";
      case "tid.userName": //1
        return "12";
      case "tid.userInformation": //1
        return "13";
      case "sid.studentPhone": //1
        return "19";
      case "sid.studentHeadmaster": //1
        return "20";
      case "sid.studentHeadmasterPhone": //1
        return "21";
      case "cid.className": //1
        return "24";
      case "cid.classEndName": //1
        return "26";
      case "cid.classActualDuration": //1
        return "29";
      case "cid.classFastln": //1
        return "32";
      case "cid.classLastOut": //1
        return "33";
      case "cid.classStartNameDFW": //
        return "25";
      case "cid.id": //1
        return "4";
      case "cid.salaryUSD": //1
        return "1";
      case "cid.salaryCNY": //1
        return "1";
      case "cid.classEndNameDFW": //
        return "26";
      case "cid.classFastlnDFW": //
        return "32";
      case "cid.classLastOutDFW": //
        return "33";
      case "cid.billDuration": //1
        return "34";
      case "coid.totalDuration": //1
        return "7";
      case "coid.leftDuration": //1
        return "8";
      case "coid.email": //1
        return "9";
      case "cid.isFree": //1
        return "35";
      case "cid.isPublic": //1
        return "36";
      case "serviceState.serviceStateId": //1
        return "38";
      case "serviceState.serviceStateName": //1
        return "37";
      default:
        return "2";
    }
  }

  /**
  * @description: 对删除的课节将进行恢复该课节信息操作
  * @param {number} e
  * @return void
  */
  recovery(e: number): void {
    let that = this.that;
    that
      .$confirm("此操作将恢复该课节信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        utils
          .requestGet("恢复课节信息", "classes/recoverydeleteClass", {
            id: e,
          })
          .then((data: any) => {
            that.$message({
              showClose: true,
              message: "恢复成功",
              type: "success",
            });
            this.loaddata(); //重新渲染
          });
      })
      .catch(() => {
        that.$message({
          type: "info",
          message: "已取消恢复",
        });
      });
  }

  /**
  * @description: 分页  尺度
  * @param {number|string} size
  * @return void
  */
  handleSizeChange(size: number | string) {
    this.queryInfo.pageSize = Number(size);
    this.loaddata();
  }

  /**
  * @description: 分页  当前页
  * @param {number|string} currentPage
  * @return void
  */
  handleCurrentChange(currentPage: number | string) {
    this.queryInfo.pageNum = Number(currentPage);
    this.loaddata();
  }

  /**
  * @description: 时间范围
  * @return void
  */
  selectData() {
    this.queryInfo.pageNum = 1;
    this.loaddata();
  }

/**
  * @description: 导师姓名筛选
  * @return void
  */
  changeTeacher() {
    this.queryInfo.pageNum = 1;
    this.loaddata();
  }

  /**
  * @description: 课节信息表格排序
  * @return void
  */
  sortChange(column: any, key: any, order: any) {
    //获取字段名称和排序类型
    var fieldName = column.column.labelClassName; //1.可以使用 var fieldName = column.column.label;   //"导师"
    var sortingType = column.order;
    var StringName = this.switchfield(fieldName);
    this.stringOrderBy = "";
    if (sortingType === "ascending") {
      this.stringOrderBy = StringName + " ASC";
      this.loaddata();
    } else if (sortingType === "descending") {
      this.stringOrderBy = StringName + " DESC";
      this.loaddata();
    } else {
      this.stringOrderBy = 32 + " desc"; //属性排序恢复默认，根据导师id排序
      this.loaddata();
    }
  }

  /**
  * @description: 渲染课节信息(已删除课节) 数据
  * @return void
  */
  loaddata() {
    utils.getUSDExchangeRate().then((rate: any) => {
      //查询信息
      utils
        .requestPost("查询已删除课节信息", "infos/selectdeleted", {
          searchSelectDate: {
            classStartName:
              this.valueTime != null && this.valueTime.length > 0
                ? this.valueTime[0]
                : "",
            classEndName:
              this.valueTime != null && this.valueTime.length > 0
                ? this.valueTime[1]
                : "",
            switchDate: this.switchValue,
          },
          page: {
            pageNum: this.queryInfo.pageNum,
            pageSize: this.queryInfo.pageSize,
          },
          stringOrderBy: this.stringOrderBy,
          teacherName: this.value,
          courseName: String(this.coursevalue),
          headmaster: String(this.headMasterValue),
          rate: rate,
          email: utils.getAccountEmail(),
          name: utils.getAccountName(),
        })
        .then((data: any) => {
          this.total = data.total > 0 ? data.total : 0;
          const dataList = data.data;
          for (let i = 0; i < dataList.length; i++) {
            if (dataList[i].cid.billDuration != "")
              if (dataList[i].cid.types == "CNY") {
                dataList[i].cid.classRatePayCNY =
                  "￥" +
                  (
                    (dataList[i].cid.classRate * dataList[i].cid.billDuration) /
                    60
                  ).toFixed(2);
                dataList[i].cid.classRatePayUSD =
                  "$" +
                  (
                    (dataList[i].cid.classRate * dataList[i].cid.billDuration) /
                    rate /
                    60
                  ).toFixed(2);
              } else {
                dataList[i].cid.classRatePayUSD =
                  "$" +
                  (
                    (dataList[i].cid.classRate * dataList[i].cid.billDuration) /
                    60
                  ).toFixed(2);
                dataList[i].cid.classRatePayCNY =
                  "￥" +
                  (
                    (dataList[i].cid.classRate *
                      dataList[i].cid.billDuration *
                      rate) /
                    60
                  ).toFixed(2);
              }
          }
          this.list = dataList;
        });
    });
  }
  /**
  * @description: 生命周期 mounted挂载后
  * @return void
  */
  mounted() {
    window.onresize = () => {
      this.tabelHeight = window.innerHeight;
    };
  }
  /**
  * @description: 生命周期 created实例创建完成
  * @return void
  */
  created() {
    this.$store.commit("loadingInformation", 0);
    this.loaddata(); //渲染课节信息(已删除课节) 数据

    //下拉菜单选择 学员查询
    utils
      .requestGet("查询课节名称", "course/select", null)
      .then((data: any) => {
        let courseName = [];
        for (let i = 0; i < data.length; i++) {
          courseName.push({ value: data[i].id, label: data[i].courseName });
        }
        this.courseName = courseName;
        utils
          .requestGet("查询学员班主任", "students/selectHeadMaster", null)
          .then((data: any) => {
            this.headMaster = data; //班主任数据渲染
          });
      });

    //下拉菜单选择 查询教师姓名
    utils
      .requestGet("查询教师姓名", "teacher/select", null)
      .then((data: any) => {
        const teacherName = [];
        for (let i = 0; i < data.length; i++) {
          teacherName.push(data[i].teacherName);
        }
        this.teacherName = teacherName;
      });
  }
}
